import { render } from "./StepCards.vue?vue&type=template&id=452897ed&scoped=true"
import script from "./StepCards.vue?vue&type=script&lang=js"
export * from "./StepCards.vue?vue&type=script&lang=js"

import "./StepCards.vue?vue&type=style&index=0&id=452897ed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452897ed"]])

export default __exports__